import { format } from 'date-fns'
import api from '../../api'
import { endpoints } from '../../apiCommons'

const authorize = async (user, password) =>
  api.post(endpoints.authorize, {
    sUsuario: user,
    sClave: password,
    dFecha: format(new Date(), 'yyyy-MM-dd'),
  })
const changePass = async (
  sUsuarioSolicitante,
  sEmpleado,
  sClaveActual,
  sClaveNueva,
) =>
  api.post(endpoints.changePass, {
    sUsuarioSolicitante,
    sEmpleado,
    sClaveNueva,
  })

export default {
  authorize,
  changePass,
}
